import { Grid, Paper, PaperProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

type DrawerActionInfoPaperProps = PaperProps & {
    children?: ReactNode;
};

export const DrawerActionInfoPaper = ({ children, sx, ...rest }: DrawerActionInfoPaperProps) => (
    <Paper
        component={Grid}
        container
        direction="column"
        rowSpacing={0}
        elevation={0}
        sx={{
            backgroundColor: '#E0EBED',
            p: 2,
            borderRadius: '8px',
            width: '100%',
            pt: 1,
            pb: 2.5,
            ...sx
        }}
        {...rest}
    >
        {children}
    </Paper>
);

export const DrawerActionInfoPaperItem = ({
    title,
    description
}: {
    title: string;
    description: string;
}) => {
    return (
        <Grid item container direction="row" alignItems="flex-start" gap={0.5} sx={{ mb: -1 }}>
            <Typography
                display="inline"
                sx={{ m: 0 }}
                variant="subtitle1"
                fontSize="1rem"
                fontWeight={700}
            >
                {title}
            </Typography>
            <Typography maxWidth={300} display="inline" sx={{ m: 0, overflowWrap: 'break-word' }} variant="body1">
                {description || '-'}
            </Typography>
        </Grid>
    );
};
